import RichText from '@eneco/components/RichText/RichText';
import { NextBestActionCardResponse } from '@eneco/dc-be/client/types.gen.js';
import { Text, TextLink } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';

export const BudgetMeterNotificationCard = ({ card }: { card: NextBestActionCardResponse }) => {
  const { fields } = useContent<DashboardOverviewRendering>();
  return (
    <StyledDashboardBlock>
      <Text>
        <RichText
          html={
            fields.currentAdvanceAmountVsRecommended?.prepaymentMeterNotification?.value?.content ??
            'Je hebt een actieve budgetmeter, klik de link hieronder voor je facturen te raadplegen [not in sitecore]'
          }
        />
      </Text>
      <TextLink href={fields.currentAdvanceAmountVsRecommended?.invoiceOverviewLink?.value?.href} emphasis="high">
        {fields.currentAdvanceAmountVsRecommended?.invoiceOverviewLink?.value?.text ||
          'Invoice overview [Not in Sitecore]'}
      </TextLink>
    </StyledDashboardBlock>
  );
};
